<div class="container-fluid">
    <div class="row">
      <div class="modal-header border-0 offset-md-10 col-md-2">
        <button mat-button mat-dialog-close type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
</div>
<div class="container-fluid pb-5 h-100">
  <cadastro-grupo-carteira [edit]="true" (editado)="grupoCarteiraEditado()" [grupoCarteira]="this.grupoCarteira" #editarGrupoCarteiraComponent></cadastro-grupo-carteira>
</div>
